import request from './request'

export function listBatch(data) {
  return request.post('/inventory/batches/list', data)
}
export function getBatch(id) {
  return request.get('/inventory/batches/' + id)
}
export function saveBatch(data) {
  return request.post('/inventory/batches', data)
}
export function updateBatch(data) {
  return request.post('/inventory/batches/update', data)
}
export function deleteBatch(ids) {
  return request.post('/inventory/batches/delete', ids)
}
